const EnvironmentTitle = ({ record }) => {
    return <span>Environment {record ? `"${record.name}"` : ''}</span>;
};

export default EnvironmentTitle;